import BigNumber from 'bignumber.js';

import { DISPENSE_AMOUNT_DECIMAL_PLACES } from './constants';

/** A dispense amount or limit rounded up to the precision the pad shows and writes it at */
export const roundUpDispenseAmount = (value: BigNumber.Value) =>
  BigNumber(value).decimalPlaces(DISPENSE_AMOUNT_DECIMAL_PLACES, BigNumber.ROUND_CEIL);
